import React      from 'react';

const noPhotosMessage = () => (
  <div className="no-albums">You have no albums</div>
);

export default noPhotosMessage;